export const SERVICE_TOP_PLATE_RESILICON = {
  label: 'Resilicon Top Plate',
  value: 'SERVICE_TOP_PLATE_RESILICON'
};
export const SERVICE_TOP_PLATE_REPLACE = {
  label: 'Replace Top Plate',
  value: 'SERVICE_TOP_PLATE_REPLACE'
};
